import * as types from './types';
import { defaultAppState } from '../../models/redux/DefaultAppState';

const AppReducer = (state = defaultAppState, action: any) => {
  switch (action.type) {
    case types.APP_COLLAPSE_SIDEBAR: {
      state = {
        ...state,
        collapseSidebar: action.payload.collapseSidebar
      };
      break;
    }
  }
  return state;
};

export { AppReducer };
